import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import NotFound from 'srcReact/components/common2/NotFound'
import ValidateRequests from 'srcReact/components/common2/ValidateRequests'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import LightProfileModal from 'srcReact/components/common2/LightProfileModal'
import MemberExceedInOrgPopin from 'srcReact/components/popinsContent/MemberExceedInOrgPopin'
import { isOrganizationManager } from 'srcReact/helpers/organizationHelper'
import { redirectToPage } from 'srcReact/helpers/history'

function InvitationsFromEnity({ workplaceId, lastRef }) {
  const { t } = useTranslation()
  const [showMemberExceedModal, setShowMemberExceedModal] = useState(false)
  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    userId: 0,
    screen: ''
  })

  const {
    organization: { current_organization },
    workplaceSettings: {
      manage_invites: { invitations: list, loading, loaded: success, error, stats }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (error && error === 'You are exceeding the limitation of users in this Organization.') {
      setShowMemberExceedModal(true)
    }
  }, [error])

  const goToMembersPage = () => {
    closeMemberExceedModal()
    const path = `/0/workplace/settings/${workplaceId}?section=link_6`
    redirectToPage(path, true)
  }

  const closeLightModal = () => {
    setModalData({
      selectedModalUser: null,
      isShowUserModal: false,
      screen: ''
    })
  }
  const openLightProfile = (userId, screen) => {
    console
    setModalData({
      userId: userId,
      isShowUserModal: true,
      screen
    })
  }

  const closeMemberExceedModal = () => {
    setShowMemberExceedModal(false)
  }

  return (
    <div className={styles.requestsWrapper}>
      {loading && <Spinner />}
      {list?.length > 0 &&
        list.map((item, index) => {
          const isLast = list.length === index + 1
          return (
            <ValidateRequests
              workplaceId={workplaceId}
              item={item}
              loading={loading}
              success={success}
              openLightProfileModal={openLightProfile}
              lastRef={isLast ? lastRef : null}
            />
          )
        })}

      {!loading && list.length === 0 && (
        <NotFound title={t('components.invite_list.notFound')} className={styles.notFound} />
      )}
      {modalData.isShowUserModal && (
        <LightProfileModal
          show={modalData.isShowUserModal}
          userIdwithRole={modalData.userId}
          closeModalWithRole={closeLightModal}
          screenWithRole={modalData.screen}
        />
      )}
      {showMemberExceedModal && (
        <MemberExceedInOrgPopin
          isOpen={showMemberExceedModal}
          closeModal={closeMemberExceedModal}
          isOrgManager={isOrganizationManager(current_organization)}
          goToMembersPage={goToMembersPage}
        />
      )}
    </div>
  )
}

export default InvitationsFromEnity
